<script>
import Swal from "sweetalert2";

// Custom components
import PageHeader from "@/components/page-header";
import UserService from "@/helpers/APIService/user.service";
import Middleware from "@/helpers/middlewares";
import errorHandler from "@/helpers/errorHandler";
import { authComputed } from "@/state/helpers";
import appConfig from "@/app.config";
import { required } from "vuelidate/lib/validators";

export default {
  page: {
    title: "Hotel List",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  data() {
    return {
      title: "Hotel List",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Hotels",
          active: true,
        },
      ],
      addEditIntent: false,
      openNewRequestForm: false,
      isEdit: false,
      tableData: [],
      updateValue: "",
      isDataLoading: false,
      is_btn_loading: false,
      hotelList: [],
      addHotelLoading: false,
      errorMessage: "",
      hotelData: [],
      tempHotelData: [],
      avatarImg: "",
      sortKey: "name",
      reverse: false,
      hotel: {
        id: "",
        hotel_name: "",
        language: "",
        language_title: "",
        language_sort_name: "",
      },
      mediaObj: {
        idle_video_file: "",
        fallback_video_file: "",
        fallback_reply: "",
      },
      search: "",
      languages: ["en_US", "es_US", "fr_FR"],
      sortedbyASC: true,
      fileUploadLoading: false,
      submitted: false,
      isSingle: false,
      selectedLang: "en_US",
      defaultHotel: "8521bf6e-5405-40e7-9684-af18dbc1b0a1",
    };
  },
  components: {
    PageHeader,
  },
  computed: {
    ...authComputed,
  },
  mounted() {
    this.getListOfIntents();
    this.getListOfHotel();
  },
  // validations: {
  //     // mediaObj: {
  //     //     idle_video_file: {
  //     //         required,
  //     //     },
  //     //     fallback_video_file: {
  //     //         required,
  //     //     },
  //     //     fallback_reply: {
  //     //         required,
  //     //     },
  //     // },
  // },
  methods: {
    // Get list of all avatar
    async getListOfHotel() {
      await UserService.getHotelsList().then((response) => {
        response.results.map((item) => {
          this.hotelData.push({
            text: item.name,
            value: { id: item.id, name: item.name },
          });
        });
      });
    },

    // Get list of all intents
    async getListOfIntents() {
      this.isDataLoading = true;

      await UserService.getVideoChatHotelList()
        .then(async (res) => {
          this.tableData = [];
          res.hotelList.map((item) => {
            let langFullName =
              item.language == "en_US"
                ? "English"
                : item.language == "es_US"
                ? "Spanish"
                : "French";
            if (
              Object.values(this.tableData).filter(
                (data) => data.id === item.hotel_id
              ).length > 0
            ) {
              let upd_obj = this.tableData.findIndex(
                (obj) => obj.id == item.hotel_id
              );
              this.tableData[upd_obj].language.push(
                require("../../../assets/images/flags/" +
                  item.language +
                  ".jpg")
              );
              this.tableData[upd_obj].language_title.push(langFullName);
              this.tableData[upd_obj].language_sort_name.push(item.language);
            } else {
              this.tableData.push({
                id: item.hotel_id,
                name: item.hotel_name,
                language: [
                  require("../../../assets/images/flags/" +
                    item.language +
                    ".jpg"),
                ],
                language_title: [langFullName],
                language_sort_name: [item.language],
              });
            }
            this.isDataLoading = false;
          });
        })
        .catch((error) => {
          this.isDataLoading = false;
          errorHandler(error);
          Middleware.notification("Something went wrong", "danger");

          if (typeof error.response.data.non_field_errors == "object") {
            this.errorMessage = error.response.data.non_field_errors;
          } else {
            this.errorMessage = error.response.data;
          }
        });
    },

    addIntentIntoHotel() {
      (this.submitted = true), (this.addHotelLoading = true);
      // this.$v.$touch();
      // if (this.$v.$invalid) {
      //     this.addHotelLoading = false;
      //     return;
      // } else {
      let count = 0;
      this.languages
        .forEach((element) => {
          UserService.getVideoChatHotelDetails(
            this.defaultHotel + "?language=" + element
          ).then((intentListResult) => {
            intentListResult.hotel_id = this.tempHotelData.id;
            intentListResult.hotel_name = this.tempHotelData.name;
            intentListResult.language = element;

            count++;
            let hotelData = intentListResult;

            console.log(intentListResult, "intentList");

            UserService.addVideoChatHotel(hotelData).then(async (res) => {
              if (count == 3) {
                this.$refs["avatar_selection_modal"].hide();

                this.addHotelLoading = false;
                Middleware.notification(
                  "Successfully added hotel & intent",
                  "success"
                );
                this.getListOfIntents();
              }
            });
          });
        })
        .catch((error) => {
          (this.submitted = false), (this.addHotelLoading = false);
          this.isDataLoading = false;
          errorHandler(error);
          Middleware.notification("Something went wrong", "success");
          if (typeof error.response.data.non_field_errors == "object") {
            this.errorMessage = error.response.data.non_field_errors;
          } else {
            this.errorMessage = error.response.data;
          }
        });
      // }
    },

    addSingleModelShow(id, name, lang, index) {
      this.isSingle = true;
      this.selectedLang = lang;
      this.tempHotelData = { id: id, name: name };
      this.$refs["avatar_selection_modal"].show();
    },

    async addSingleLanguage() {
      (this.submitted = true), (this.addHotelLoading = true);
      // this.$v.$touch();
      // if (this.$v.$invalid) {
      //     this.addHotelLoading = false;
      //     return;
      // } else {

      await UserService.getVideoChatHotelDetails(
        this.defaultHotel + "?language=" + this.selectedLang
      )
        .then((intentListResult) => {
          intentListResult.hotel_id = this.tempHotelData.id;
          intentListResult.hotel_name = this.tempHotelData.name;
          intentListResult.language = this.selectedLang;

          let hotelData = intentListResult;
          UserService.addVideoChatHotel(hotelData).then(async (res) => {
            this.$refs["avatar_selection_modal"].hide();

            this.addHotelLoading = false;
            Middleware.notification("Successfully added language", "success");
            this.getListOfIntents();
          });
        })
        .catch((error) => {
          this.addHotelLoading = false;
          this.isDataLoading = false;
          errorHandler(error);
          Middleware.notification("Something went wrong", "success");
          if (typeof error.response.data.non_field_errors == "object") {
            this.errorMessage = error.response.data.non_field_errors;
          } else {
            this.errorMessage = error.response.data;
          }
        });
      // }
    },

    deleteModelShow(data) {
      this.hotel = data;
      this.$refs["delete_hotel_modal"].show();
    },

    async deleteHotel(data) {
      this.addHotelLoading = true;
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#238dfa",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (result.value) {
          UserService.deleteVideoChatHotel(data)
            .then((response) => {
              this.addHotelLoading = false;
              this.getListOfIntents();
              this.$refs["delete_hotel_modal"].hide();
              Middleware.notification("Successfully Deleted!", "success");
            })
            .catch((error) => {
              errorHandler(error);
              this.addHotelLoading = false;
              Middleware.notification("Something went wrong", "success");

              if (typeof error.response.data.non_field_errors == "object") {
                this.errorMessage = error.response.data.non_field_errors;
              } else {
                this.errorMessage = error.response.data;
              }
            });
        }
      });
    },

    redirectHotelIntestListPage(id, lang) {
      this.$router.push({
        path: "/ai-bot/hotel-wise-intent-list",
        query: {
          hotel: id,
          lang: lang,
        },
      });
    },

    sortList(sortBy) {
      if (this.sortedbyASC) {
        this.tableData.sort((x, y) => (x[sortBy] > y[sortBy] ? -1 : 1));
        this.sortedbyASC = false;
      } else {
        this.tableData.sort((x, y) => (x[sortBy] < y[sortBy] ? -1 : 1));
        this.sortedbyASC = true;
      }
    },

    selectHotel() {
      this.isSingle = false;
      this.$refs["avatar_selection_modal"].show();
    },

    async uploadFile(event, type) {
      let fileObject = "";
      let fileName = "";

      if (type == "idle_video_file") {
        fileObject = event.target.files[0];
        this.mediaObj.idle_video_file = this.randomString(5) + ".mp4";
        fileName = { file_name: this.mediaObj.idle_video_file };
      } else if (type == "fallback_video_file") {
        fileObject = event.target.files[0];
        this.mediaObj.fallback_video_file = this.randomString(5) + ".mp4";
        fileName = { file_name: this.mediaObj.fallback_video_file };
      }

      this.fileUploadLoading = true;
      await UserService.mediaFileUrlGenerate(fileName)
        .then((response) => {
          let fileUrl = response.url;
          UserService.mediaFileUpload(fileUrl, fileObject).then((res) => {
            this.fileUploadLoading = false;
            this.submitted = false;
            Middleware.notification(
              "Successfully upload media file !!",
              "success"
            );
          });
        })
        .catch((error) => {
          this.fileUploadLoading = false;
          this.createError = true;
          errorHandler(error);
          Middleware.notification("Something went wrong !!", "danger");
          if (typeof error.response.data.non_field_errors == "object") {
            this.errorMessage = error.response.data.non_field_errors;
          } else {
            this.errorMessage = error.response.data;
          }
        });
    },

    randomString(length) {
      var result = "";
      var characters = "abcdefghijklmnopqrstuvwxyz";
      var charactersLength = characters.length;
      for (var i = 0; i < length; i++) {
        result += characters.charAt(
          Math.floor(Math.random() * charactersLength)
        );
      }
      return result;
    },
  },
};
</script>

<template>
  <div>
    <PageHeader
      :title="title"
      :items="items"
      :action="selectHotel"
      :isButton="true"
      text="Add New Hotel"
    />

    <div class="card">
      <div class="card-body">
        <div class="table-responsive">
          <table class="table">
            <thead class="table-light">
              <tr>
                <th @click="sortList('id')">Hotel ID &#8597;</th>
                <th @click="sortList('name')">Hotel Name &#8597;</th>
                <th>Language</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody v-if="isDataLoading">
              <tr v-for="(item, index) in 10" :key="index">
                <td class="placeholder-glow" v-for="no in 4" :key="no">
                  <span class="placeholder w-100 placeholder-lg"></span>
                </td>
              </tr>
            </tbody>
            <tbody v-else>
              <tr v-for="(data, index) in tableData" :key="data.id">
                <td @click="openBotDrawer(data.id, index)">
                  {{ data.id }}
                </td>
                <td class="text-wrap">
                  {{ data.name }}
                </td>
                <td>
                  <div v-show="!addHotelLoading[index]">
                    <button
                      v-for="(lang, ind) in data.language_sort_name"
                      :key="ind"
                      class="ms-2 btn btn-success"
                      @click="redirectHotelIntestListPage(data.id, lang)"
                    >
                      {{
                        lang == "en_US"
                          ? "English"
                          : lang == "es_US"
                          ? "Spanish"
                          : "French"
                      }}
                    </button>
                    <button
                      v-for="(lang, ind) in languages.filter(
                        (item) => !data.language_sort_name.includes(item)
                      )"
                      :key="ind"
                      class="ms-2 btn btn-outline-primary"
                      @click="
                        addSingleModelShow(data.id, data.name, lang, index)
                      "
                    >
                      {{
                        lang == "en_US"
                          ? "English"
                          : lang == "es_US"
                          ? "Spanish"
                          : "French"
                      }}
                    </button>
                  </div>
                  <div
                    class="spinner-border spinner-border-primary spinner-primary spinner-border-sm"
                    role="status"
                    v-show="addHotelLoading[index]"
                  >
                    <span class="sr-only">Loading...</span>
                  </div>
                </td>
                <td>
                  <span
                    v-if="data.id != '8521bf6e-5405-40e7-9684-af18dbc1b0a1'"
                  >
                    <i
                      @click="deleteModelShow(data)"
                      class="far fa-trash-alt fs-2 text-danger"
                    ></i>
                  </span>
                  <span v-else class="text-center">-</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <b-modal
      id="modal-"
      size="md"
      ref="avatar_selection_modal"
      title="Add New AI Bot Hotel"
      title-class="font-18"
      headerClass="border-bottom-0 justify-content-center"
      centered
      hide-footer
    >
      <div class="row">
        <div class="col-md-8 mx-auto">
          <label for="">Select Hotel</label>
          <b-form-select
            class="form-select"
            id="company-type-input"
            :options="hotelData"
            v-model="tempHotelData"
          >
          </b-form-select>
          <div class="text-muted text-center">
            <div
              class="spinner-border spinner-border-primary spinner-primary spinner-border-lg mt-3"
              role="status"
              v-show="addHotelLoading"
            >
              <span class="sr-only">Loading...</span>
            </div>
            <button
              class="btn btn-primary w-100 mt-3"
              @click="addIntentIntoHotel()"
              v-show="!addHotelLoading"
            >
              Add
            </button>
          </div>
        </div>
      </div>
    </b-modal>

    <b-modal
      id="modal-"
      :size="hotel.language_sort_name.length == 3 ? 'xl' : 'lg'"
      ref="add_hotel_modal"
      :title="'Which Language Add From ' + hotel.name + 'Hotel'"
      title-class="font-18"
      headerClass="justify-content-center"
      centered
      hide-footer
    >
      <div class="fixTableHead">
        <div class="row justify-content-center">
          <div
            :class="
              hotel.language_sort_name.length == 3 ? 'col-md-3' : 'col-md-4'
            "
            v-for="(data, index) in hotel.language_sort_name"
            :key="index"
          >
            <div class="card">
              <div class="card-body text-center">
                <div class="">
                  <img
                    :src="
                      require('../../../assets/images/flags/' + data + '.jpg')
                    "
                    alt=""
                    class="avatar-lg rounded-circle img-thumbnail object-fit"
                  />
                  <div class="text-muted">
                    <h5>
                      {{
                        data == "en_US"
                          ? "English"
                          : data == "es_US"
                          ? "Spanish"
                          : "French"
                      }}
                    </h5>
                    <div
                      class="spinner-border spinner-border-primary spinner-primary spinner-border-sm"
                      role="status"
                      v-show="addHotelLoading"
                    >
                      <span class="sr-only">Loading...</span>
                    </div>
                    <button
                      class="btn btn-primary btn-sm"
                      @click="addSingleLanguage(hotel.id, hotel.name, data)"
                      v-show="!addHotelLoading"
                    >
                      Add
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-modal>

    <b-modal
      id="modal-"
      :size="hotel.language_sort_name.length == 3 ? 'xl' : 'lg'"
      ref="delete_hotel_modal"
      :title="'Which Language Delete From ' + hotel.name + 'Hotel'"
      title-class="font-18"
      headerClass="justify-content-center"
      centered
      hide-footer
    >
      <div class="fixTableHead">
        <div class="row justify-content-center">
          <div
            :class="
              hotel.language_sort_name.length == 3 ? 'col-md-3' : 'col-md-4'
            "
            v-for="(data, index) in hotel.language_sort_name"
            :key="index"
          >
            <div class="card">
              <div class="card-body text-center">
                <div class="">
                  <img
                    :src="
                      require('../../../assets/images/flags/' + data + '.jpg')
                    "
                    alt=""
                    class="avatar-lg rounded-circle img-thumbnail object-fit"
                  />
                  <div class="text-muted">
                    <h5 class="my-2">
                      {{
                        data == "en_US"
                          ? "English"
                          : data == "es_US"
                          ? "Spanish"
                          : "French"
                      }}
                    </h5>
                    <div
                      class="spinner-border spinner-border-primary spinner-primary spinner-border-sm"
                      role="status"
                      v-show="addHotelLoading"
                    >
                      <span class="sr-only">Loading...</span>
                    </div>
                    <button
                      class="btn btn-primary btn-sm"
                      @click="deleteHotel(hotel.id + '?language=' + data)"
                      v-show="!addHotelLoading"
                    >
                      Delete
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<!-- <b-modal id="modal-" size="xl" ref="avatar_selection_modal" title="Select Avatar" title-class="font-18"
            headerClass="justify-content-center" centered hide-footer>
            <div class="row">
                <div class="col-md-3 mx-auto" v-for="data in avatarData" :key="data.id">
                    <div class="card">
                        <div class="card-body text-center">
                            <div class="">
                                <img :src="'https://vod-lex-files.s3.amazonaws.com/' + data.photo" alt=""
                                    class="avatar-lg rounded-circle img-thumbnail object-fit" />
                                <div class="text-muted">
                                    <h5>{{ data.name }}</h5>
                                    <div class="spinner-border spinner-border-primary spinner-primary spinner-border-sm"
                                        role="status" v-show="addHotelLoading">
                                        <span class="sr-only">Loading...</span>
                                    </div>
                                    <button class="btn btn-primary btn-sm" @click="addIntentIntoHotel(data)"
                                        v-show="!addHotelLoading">
                                        Select
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </b-modal> -->
<!-- 
async getListOfIntents() {
    this.isDataLoading = true;
    let tempHotelData = [];

    await UserService.getVideoChatHotelList()
        .then(async (res) => {
            tempHotelData = res.hotelList;
            await UserService.getHotelsList().then((result) => {
                result.results.map((item) => {
                    if (
                        tempHotelData.length > 0 &&
                        tempHotelData.some(
                            (hotelData) => hotelData.hotel_id === item.id
                        )
                    ) {
                        UserService.getVideoChatHotelDetails(item.id).then(
                            (hotelDetails) => {
                                this.tableData.push({
                                    id: item.id,
                                    name: item.name,
                                    avatar_img: hotelDetails.photo ?
                                        "https://vod-lex-files.s3.amazonaws.com/" +
                                        hotelDetails.photo : " ",
                                    avatar_name: hotelDetails.name ? hotelDetails.name : '',
                                    is_intent_add: true,
                                });
                            }
                        );
                    } else {
                        this.tableData.push({
                            id: item.id,
                            name: item.name,
                            avatar_img: "",
                            avatar_name: "",
                            is_intent_add: false,
                        });
                    }
                });
            });
            this.isDataLoading = false;
        })
        .catch((error) => {
            this.isDataLoading = false;
            errorHandler(error);
            Middleware.notification("Something went wrong", "danger");

            if (typeof error.response.data.non_field_errors == "object") {
                this.errorMessage = error.response.data.non_field_errors;
            } else {
                this.errorMessage = error.response.data;
            }
        });
}, -->

<!-- async addIntentIntoHotel(data) {
    this.addHotelLoading = true;
    await UserService.getBotAvatarDetails(data.id)
        .then(async (avatar) => {
            let hotelData = {
                hotel_id: this.tempHotelData.id,
                hotel_name: this.tempHotelData.name,
                ...avatar,
            };
            await UserService.addVideoChatHotel(hotelData).then(async (res) => {
                this.$refs["avatar_selection_modal"].hide();

                this.addHotelLoading = false;
                Middleware.notification(
                    "Successfully added hotel & intent",
                    "success"
                );

                this.tableData = this.tableData.map((table) => {
                    if (table.id === this.tempHotelData.id) {
                        table.is_intent_add = true;
                    }
                    return table;
                    //   });
                    // });
                });
            });
        })
        .catch((error) => {
            this.addHotelLoading = false;
            this.isDataLoading = false;
            errorHandler(error);
            Middleware.notification("Something went wrong", "success");
            if (typeof error.response.data.non_field_errors == "object") {
                this.errorMessage = error.response.data.non_field_errors;
            } else {
                this.errorMessage = error.response.data;
            }
        });
}, -->
